<template>
  <v-container bg fill-height align="center" grid-list-md text-xs-center v-on:keyup.13="login">
    <v-layout align-center justify-center style="margin: 0px">
      <v-flex class="middle" xs12 sm8 md4>
        <v-layout class="mb-3">
          <img src="../assets/cropped-pak.png" alt="background" />
        </v-layout>
        <v-card class="elevation-12">
          <v-toolbar dark class="toolbar">
            <v-toolbar-title>АДМИНИСТРАТОР</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field v-model="username" prepend-icon="person" name="username" label="Username" id="username" type="text"></v-text-field>
              <v-text-field v-model="password" prepend-icon="lock" name="password" label="Password" id="password" :type="showPassword ? 'text' : 'password'">
                <template v-slot:append>
                  <v-btn icon @click="showPassword = !showPassword">
                    <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <div v-if="loginError" class="error-infobox">
            {{ loginError }}
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn dark color="darkgreen" class="btnLogin" v-on:click="login()">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
    };
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "loginSuccessful"]),
  },
  methods: {
    ...mapActions(["doLogin"]),
    login() {
      this.doLogin({
        username: this.username,
        password: this.password,
      });
    },
  },
};
</script>
